<div class="json-container-header w-50 mx-auto my-3">
  <span>
    {{ 'Fields marked with' | translate }}
    <span class="text-primary">"*"</span>
    {{ 'are required fields.' | translate }} </span
  ><br />
  <span>
    {{ 'Fields marked with' | translate }}
    <span class="text-primary">"+"</span>
    {{ 'are hidden fields.' | translate }}
  </span>
</div>

<div class="json-container w-50 mx-auto">
  <irembogov-json-viewer [data]="data"></irembogov-json-viewer>
</div>
